import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setCountryOptions } from '../store/options.actions'

export function* getCountryOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const countryResponse: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getCountryOptions,
    ])
    const { entity } = countryResponse
    yield put(setCountryOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCountryOptions() error: ${e}`))
  }
}

export function* getCountryOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCountryOptions)
}
